export const brochureHero = {
  title: '資料請求',
  titleEn: 'BROCHURE',
  lead: 'コース内容や料金をまとめた資料を、無料でPDFにてお送りします。',
};

export const brochureContents = [
  {
    icon: 'ri-building-2-line',
    title: 'アカデミー概要',
    titleEn: 'Academy Overview',
    description: '日本執事アカデミーの設立趣旨、教育理念、運営体制についてご紹介します。',
  },
  {
    icon: 'ri-book-open-line',
    title: '3コースの内容と料金',
    titleEn: 'Courses & Pricing',
    description: 'エッセンシャル・アドバンス・マスターの各コースについて、学習内容と受講料の内訳を詳しく掲載しています。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'カリキュラムと年間スケジュール',
    titleEn: 'Curriculum & Schedule',
    description: '学びの全体像、日々の時間割、年間の開校予定を一覧でご確認いただけます。',
  },
  {
    icon: 'ri-award-line',
    title: '認定資格・修了証',
    titleEn: 'Certification',
    description: '修了時に取得できる協会認定資格と、その活用方法についてまとめています。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '申込方法',
    titleEn: 'Application Process',
    description: '応募資格から入学のお申込み手順まで、受講開始までの流れをわかりやすくご案内します。',
  },
];

export const brochureDeliveryMethods = [
  { value: 'pdf', label: 'PDF送付（メール）', description: 'ご入力いただいたメールアドレスに、資料のPDFを送付します。すぐにご覧いただけます。' },
];

export const brochureCourseOptions = [
  { value: 'essential', label: 'エッセンシャルコース' },
  { value: 'advanced', label: 'アドバンスコース' },
  { value: 'master', label: 'マスターコース' },
  { value: 'undecided', label: 'まだ決めていない' },
];

export const brochureFaqs = [
  {
    question: '資料は無料ですか?',
    answer: 'はい。無料でPDFにてお送りします。',
  },
  {
    question: 'どんな資料が届きますか?',
    answer: 'アカデミー概要、3コースの内容と料金、カリキュラム、認定資格、年間スケジュール、申込方法などをまとめた資料です。',
  },
  {
    question: 'しつこい勧誘はありますか?',
    answer: 'ご希望のない方への過度なご連絡はいたしません。ご相談を希望される場合のみ、担当者よりご案内します。',
  },
];

export const brochureRelatedPages = [
  {
    title: '個別相談予約',
    description: '無料・オンライン可の相談',
    href: '/consultation',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
  {
    title: '体験講座',
    description: '1日で執事の所作を体験',
    href: '/seminar',
  },
  {
    title: 'お問い合わせ',
    description: 'ご質問・ご相談の窓口',
    href: '/contact',
  },
];